import React, { useState } from 'react';
import { ClientApiProps, IAssessmentApplicationEx } from '../../common';
import { Acma_amateurradioassessment_statuscode, Address, AssessmentApplication, getApiClient } from '../../api';
import { Form } from 'acma-spa';
import { useNavigate, useParams } from 'react-router-dom';
import { CertificateApplicationPage } from './Page';

export interface CertificateApplicationFormParams {
  [keys: string]: string | undefined;
  id?: string;
}

export interface CertificateApplicationFormProps extends ClientApiProps {}

export const CertificateApplicationForm: React.FC<CertificateApplicationFormProps> = (props) => {
  const params = useParams<CertificateApplicationFormParams>();
  const navigate = useNavigate();

  const [readOnly, setReadOnly] = useState(false);

  const getNextPage = () => 0;
  const getPreviousPage = (page: number) => (page > 0 ? page - 1 : 0);
  const load: { (): Promise<[IAssessmentApplicationEx, number]> } = async () => {
    const [client] = getApiClient(props.baseUrl, props.b2cDomainName, props.msalClient);

    const res = await client.assessmentApplicationGet(params.id ?? '');
    setReadOnly(res.status != Acma_amateurradioassessment_statuscode.Approved);

    return [res, 0];
  };

  const save = async (m: IAssessmentApplicationEx): Promise<IAssessmentApplicationEx> => {
    const application = new AssessmentApplication({
      ...m,
      address1: new Address(m.address1),
    });

    const [client] = getApiClient(props.baseUrl, props.b2cDomainName, props.msalClient);

    const data = await client.assessmentApplicationSubmit(application);
    window.scroll(0, 0);

    if (data.error) {
      window.scroll(0, 0);
      throw new Error(data.error);
    }

    return data.application ?? m;
  };

  return (
    <>
      <h1>Certificate application</h1>

      <Form<IAssessmentApplicationEx>
        onLoad={load}
        getNextPage={getNextPage}
        getPreviousPage={getPreviousPage}
        readOnly={readOnly}
        onSubmit={(m) => save(m)}
        onExit={() => {
          // Go back to the operator screen.
          navigate('/amateurradio/operator');
          return undefined;
        }}>
        {(ctx) => {
          switch (ctx?.page) {
            case 0:
              return <CertificateApplicationPage ctx={ctx} {...props} />;
            default:
              return <></>;
          }
        }}
      </Form>
    </>
  );
};
